<div class="flex flex-col gap-6">

  <div class="flex flex-wrap gap-6 items-start">

    <!-- System Job Status -->
    <div class="flex flex-col gap-4 w-1/3">
      <div class="ec-category-header">
        {{ 'dashboard.overview.systemstatus.title' | translate }}
      </div>

      <div class="bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border shadow-sm overflow-hidden">
        @if (systemLoading) {
          @for (i of [1,2,3,4]; track i) {
            <div class="flex items-stretch border-b border-gray-100 dark:border-dark-border last:border-0">
              <div class="w-1.5 bg-gray-100 dark:bg-dark-border animate-pulse shrink-0"></div>
              <div class="flex items-center gap-4 px-4 py-3.5 flex-1">
                <div class="h-3.5 w-2/3 rounded-full bg-gray-100 dark:bg-dark-border animate-pulse flex-1"></div>
                <div class="h-3 w-8 rounded-full bg-gray-100 dark:bg-dark-border animate-pulse shrink-0"></div>
              </div>
            </div>
          }
        } @else {
          @for (job of systemJobs; track job.jobName) {
            <div class="flex items-stretch border-b border-gray-100 dark:border-dark-border last:border-0">
              <!-- Coloured left border -->
              <div class="w-1.5 shrink-0 transition-colors duration-300" [class]="accentClass(job)"></div>
              <!-- Content -->
              <div class="flex items-center gap-4 px-4 py-3.5 flex-1">
                <div class="flex-1 text-xs text-gray-400 dark:text-gray-500">
                  {{ ('dashboard.overview.systemstatus.' + (job.jobName | lowercase)) | translate }}
                </div>
                <div class="text-sm font-medium shrink-0" [class]="statusTextClass(job)">
                  {{ statusLabel(job) }}
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>

  </div>

</div>
